/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { DOWNLOAD_INVOICE } from 'pages/Invoices/InvoicesGraphQL';
import Loader from 'components/common/Loader';
import Base64ToPdf from 'pages/Invoices/components/PDFViewer';

const getReadableError = (apiError, fallbackMessage) => {
  const graphQlMessage = apiError?.graphQLErrors?.[0]?.message;
  const networkMessage = apiError?.networkError?.result?.errors?.[0]?.message;
  const message = graphQlMessage || networkMessage || apiError?.message;
  return message || fallbackMessage;
};

function InvoicePdf({ id }) {
  const { data, loading, error, refetch } = useQuery(DOWNLOAD_INVOICE, {
    variables: { invoiceId: id },
    fetchPolicy: 'network-only',
    skip: !id,
  });

  useEffect(() => {
    if (id) {
      refetch({ invoiceId: id });
    }
  }, [id]);

  if (!id) {
    return 'Invoice ID is not available.';
  }
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return getReadableError(
      error,
      'Error while getting your pdf. Please refresh the page or try again later',
    );
  }
  if (data?.downloadInvoice) {
    return <Base64ToPdf url={data?.downloadInvoice} />;
  }
  return 'Invoice document is not available.';
}

export default InvoicePdf;
